import React from 'react';
import { Instagram, Facebook, Phone, MapPin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-surface border-t border-ink/8 pt-14 pb-8 px-4 md:px-8" data-id="element-64">
      <div className="max-w-7xl mx-auto" data-id="element-65">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-16 mb-12" data-id="element-66">
          {/* Brand */}
          <div data-id="element-67">
            <a href="#inicio" className="inline-block mb-5" data-id="element-68">
              <span className="font-heading font-bold text-lg uppercase tracking-[0.2em]" data-id="element-69">
                <span className="text-ink" data-id="element-70">Corte </span>
                <span className="text-fire" data-id="element-71">Quiteño</span>
              </span>
            </a>
            <p className="text-muted text-sm font-light leading-relaxed mb-6 max-w-xs italic font-heading" data-id="element-72">
              "La experiencia premium de la parrilla, en tu hogar."
            </p>
            <div className="flex gap-4" data-id="element-73">
              <a href="#" className="text-muted hover:text-fire transition-colors" data-id="element-74">
                <Instagram className="w-4 h-4" data-id="element-75" />
              </a>
              <a href="#" className="text-muted hover:text-fire transition-colors" data-id="element-76">
                <Facebook className="w-4 h-4" data-id="element-77" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-78">
            <h4 className="text-[10px] uppercase tracking-[0.2em] text-muted mb-6" data-id="element-79">
              Navegación
            </h4>
            <ul className="space-y-3" data-id="element-80">
              {[{
              name: 'Inicio',
              href: '#inicio'
            }, {
              name: 'Packs',
              href: '#packs'
            }, {
              name: 'Catálogo',
              href: '#catalogo'
            }, {
              name: 'Nuestra Calidad',
              href: '#calidad'
            }].map(link => <li key={link.name} data-id="element-81">
                  <a href={link.href} className="text-sm text-muted hover:text-fire transition-colors font-light" data-id="element-82">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-83">
            <h4 className="text-[10px] uppercase tracking-[0.2em] text-muted mb-6" data-id="element-84">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-85">
              <li className="flex items-start gap-3" data-id="element-86">
                <Phone className="w-3.5 h-3.5 mt-0.5 text-fire flex-shrink-0" data-id="element-87" />
                <span className="text-sm text-muted font-light" data-id="element-88">
                  +593 99 999 9999
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-89">
                <Mail className="w-3.5 h-3.5 mt-0.5 text-fire flex-shrink-0" data-id="element-90" />
                <span className="text-sm text-muted font-light" data-id="element-91">
                  pedidos@cortequiteno.com
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-92">
                <MapPin className="w-3.5 h-3.5 mt-0.5 text-fire flex-shrink-0" data-id="element-93" />
                <span className="text-sm text-muted font-light leading-relaxed" data-id="element-94">
                  Quito, Ecuador
                  <br data-id="element-95" />
                  Distrito Metropolitano
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-ink/8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-96">
          <p className="text-[10px] uppercase tracking-[0.15em] text-muted/60" data-id="element-97">
            © {new Date().getFullYear()} Corte Quiteño — Todos los derechos
            reservados
          </p>
          <div className="flex gap-6" data-id="element-98">
            <a href="#" className="text-[10px] uppercase tracking-[0.12em] text-muted/60 hover:text-fire transition-colors" data-id="element-99">
              Términos
            </a>
            <a href="#" className="text-[10px] uppercase tracking-[0.12em] text-muted/60 hover:text-fire transition-colors" data-id="element-100">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}